import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d1ef74f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "page"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_headline = _resolveComponent("page-headline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.content)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_page_headline, { content: _ctx.content }, null, 8, ["content"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "container ql-editor",
              innerHTML: _ctx.content?.description
            }, null, 8, _hoisted_3)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.content)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Not found"))
      : _createCommentVNode("", true)
  ], 64))
}